import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

import SetPasswordForm from '../../../../components/forms/Auth/SetPasswordForm';
import withLoadingState from '../../../../helpers/withLoadingState';
import { getCheckAuthCode } from '../../../../redux/auth/selectors';

interface SetPasswordProps {
  token: string;
}

const SetPassword = ({ token }: SetPasswordProps) => {
  const { t } = useTranslation();
  const { data } = useSelector(getCheckAuthCode);

  return (
    <>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        align="center"
        gutterBottom
        style={{ marginBottom: '2rem' }}
      >
        ({t('profile.account_reset_password_info_text')}
        <b>{data['e-mail']}</b>)
      </Typography>
      <SetPasswordForm token={token} />
    </>
  );
};

export default withLoadingState(SetPassword);
